import Vue from "vue";
import Router from "vue-router";

// Container
const MainContainer = () => import("@/containers/MainContainer");

// Pages
const PageNotFound = () => import("@/pages/PageNotFound");
const ProductList = () => import("@/pages/ProductList");
const ProductDetail = () => import("@/pages/ProductDetail");
const About = () => import("@/pages/About");
const HowGroupBuyingWorks = () => import("@/pages/HowGroupBuyingWorks");

Vue.use(Router);

function configRoutes() {
  return [
    {
      path: "/shop/:id",
      exact: true,
      redirect: "/shop/:id/products-list",
      name: "Home",
      component: MainContainer,
      children: [
        {
          path: "/shop/how-group-buying-works",
          exact: true,
          name: "HowGroupBuyingWorks",
          component: HowGroupBuyingWorks,
        },
        {
          path: "/shop/:id/products-list",
          exact: true,
          name: "ProductList",
          component: ProductList,
        },
        {
          path: "/shop/:id/product-detail/:productid",
          exact: true,
          name: "ProductDetail",
          component: ProductDetail,
        }
      ],
    },
    {
      path: "/about",
      exact: true,
      name: "about",
      component: About
    },
    { path: "*", component: PageNotFound },
  ];
}

export default new Router({
  mode: "history",
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes(),
});
